import { IHome } from "@src/components/Home";
import React from "react";
import ClientOnly from "@src/components/ClientOnly";
import Floater from "../Floater";
import Footer from "../Footer";
import Vendors from "../Vendors";
import Parts from "../Parts";
import Backstory from "../Backstory";
import MarqueeComp from "../MarqueeComp";
import Quotes from "../Quotes";
import Masonry from "../Masonry";
import Hero from "../Hero";
import AsoEbi from "../AsoEbiLink";
import { useEventParts } from "@src/hooks/useEventParts";
import { useHome } from "@src/hooks/useHome";

const HomeBT1: React.FC<IHome> = ({
  slug,
  eventBySlugData,
  eventId,
  eventPartsData,
  backStoryData,
  eventVendorData,
  albumDetailsData,
  heroImageData,
  hasWallet,
  getEventStreamersData,
  liveSchedules,
  eventUuid,
  weddingPartyData,
  inviteResult: initialInviteResult,
}) => {
  const {
    accessToken,
    inviteResult,
    getAsoebiData,
    isCashGiftSetup,
    isInvitedToEvent,
  } = useHome({
    slug,
    eventBySlugData,
    eventId,
    eventPartsData,
    backStoryData,
    eventVendorData,
    albumDetailsData,
    heroImageData,
    hasWallet,
    getEventStreamersData,
    liveSchedules,
    eventUuid,
    weddingPartyData,
    inviteResult: initialInviteResult,
  });
  const { parts } = useEventParts({
    eventPartsData,
    liveSchedules,
    eventTimezone: eventBySlugData?.eventBySlug?.eventTimezone,
    isInvitedToEvent,
  });
  return (
    <>
      <ClientOnly>
        <Floater
          accessToken={accessToken}
          eventId={eventId}
          eventUuid={eventUuid}
          slugData={eventBySlugData}
          hasWallet={hasWallet}
          getEventStreamersData={getEventStreamersData}
          liveSchedules={liveSchedules}
          access_control={
            eventBySlugData?.eventBySlug?.event_preference?.access_control ??
            false
          }
          qr_code={inviteResult?.signupByInviteLink?.invitation?.qr_code ?? ""}
          getAsoebiData={getAsoebiData}
          admits={inviteResult?.signupByInviteLink?.invitation?.admits ?? 1}
          invitation={inviteResult?.signupByInviteLink?.invitation}
          isInvitedToEvent={isInvitedToEvent}
        />
        <Hero
          heroImageData={heroImageData}
          eventId={eventId}
          slugData={eventBySlugData}
        />
        <Masonry
          eventSlug={slug}
          eventId={eventId}
          albumDetailsData={albumDetailsData}
        />
        <Parts
          liveSchedules={liveSchedules}
          eventId={eventId}
          parts={parts}
          eventPartsData={eventPartsData}
          eventTimezone={eventBySlugData?.eventBySlug?.eventTimezone}
        />
        <Quotes albumDetailsData={albumDetailsData} />

        {accessToken && (getAsoebiData?.getAseobi?.length ?? 0) > 0 && (
          <AsoEbi
            eventUuid={eventUuid}
            eventId={eventId}
            showAsoebi={accessToken ? true : false}
            // showAsoebi={true}
            showCashGift={!!accessToken && isCashGiftSetup}
            isCashGiftSetup={isCashGiftSetup}
            availableGiftPaymentCurrencies={
              eventBySlugData?.eventBySlug?.available_gift_payment_currencies ??
              []
            }
          />
        )}

        <Backstory eventId={eventId} backStoryData={backStoryData} />

        <MarqueeComp eventId={eventId} slugData={eventBySlugData} />

        <Vendors eventId={eventId} eventVendorData={eventVendorData} />

        <Footer slug={eventBySlugData} />
      </ClientOnly>
    </>
  );
};

export default HomeBT1;
